import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import {
  type CardLayoutModelType,
  type CardLayoutModelConstructorType,
} from '../../types';

export class CapacityTeamTags extends Field {
  static subqueriesForModel(
    modelClass: CardLayoutModelConstructorType
  ): Record<string, any> {
    return { currentSchedulingTeams: ['name', 'color'] };
  }

  static availableForModel(modelClass, recordLayout) {
    if (!window.currentAccount?.enhancedCapacityPlanning) {
      return false;
    }

    return super.availableForModel(modelClass, recordLayout);
  }

  get title() {
    return 'Capacity planning teams';
  }

  exampleContents(): FieldContentsData {
    return {
      tags: [
        { name: 'Example team 1', color: '#0173cf' },
        { name: 'Example team 2', color: '#674c75' },
      ],
    };
  }

  contentsForRecord(
    record: Extract<CardLayoutModelType, { currentSchedulingTeams: any }>
  ): FieldContentsData {
    if (record.currentSchedulingTeams) {
      return {
        tags: record.currentSchedulingTeams.map(team => ({
          name: team.name,
          color: team.colorObject.hex(),
        })),
      };
    }

    return {};
  }
}
